<div class="spb-page">
  <!-- Page header -->
  <header class="spb-header">
    <div class="spb-header__text">
      <h1 class="spb-title" translate>SALESPERSON_BUDGETS</h1>
      <p class="spb-subtitle" translate>SALESPERSON_BUDGETS_SUBTITLE</p>
    </div>

    <div class="spb-header__actions">
      <label class="spb-btn spb-btn--ghost">
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
          <path fill="currentColor" d="M8 1.5a.75.75 0 0 1 .53.22l3 3a.75.75 0 1 1-1.06 1.06L8.75 4.56v6.19a.75.75 0 0 1-1.5 0V4.56L5.53 5.78A.75.75 0 1 1 4.47 4.72l3-3A.75.75 0 0 1 8 1.5ZM2.75 12.25a.75.75 0 0 1 .75.75v.25h9V13a.75.75 0 0 1 1.5 0v.75a.75.75 0 0 1-.75.75h-10.5a.75.75 0 0 1-.75-.75V13a.75.75 0 0 1 .75-.75Z"/>
        </svg>
        <span translate>IMPORT_EXCEL</span>
        <input
          type="file"
          class="d-none"
          accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (change)="onImportFileSelected($event)" />
      </label>

      <button type="button" class="spb-btn spb-btn--ghost" (click)="exportExcel()">
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
          <path fill="currentColor" d="M8 11.5a.75.75 0 0 1-.53-.22l-3-3a.75.75 0 1 1 1.06-1.06L7.25 8.94V2.75a.75.75 0 0 1 1.5 0v6.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-.53.22ZM2.75 13a.75.75 0 0 1 .75.75v.25h9v-.25a.75.75 0 0 1 1.5 0v.5a.75.75 0 0 1-.75.75h-10.5a.75.75 0 0 1-.75-.75v-.5a.75.75 0 0 1 .75-.75Z"/>
        </svg>
        <span translate>EXPORT_EXCEL</span>
      </button>

      <button type="button" class="spb-btn spb-btn--primary" (click)="addRow()" [disabled]="loading">
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
          <path fill="currentColor" d="M8 2.75a.75.75 0 0 1 .75.75v3.75h3.75a.75.75 0 0 1 0 1.5H8.75v3.75a.75.75 0 0 1-1.5 0V8.75H3.5a.75.75 0 0 1 0-1.5h3.75V3.5A.75.75 0 0 1 8 2.75Z"/>
        </svg>
        <span translate>ADD_ROW</span>
      </button>
    </div>
  </header>

  <!-- Toolbar: year + summary -->
  <section class="spb-toolbar">
    <div class="spb-year">
      <span class="spb-year__label" translate>YEAR</span>
      <div class="spb-year__control">
        <button
          type="button"
          class="spb-year__step"
          (click)="prevYear()"
          [disabled]="loading"
          aria-label="Previous year">
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <path fill="currentColor" d="M10.28 3.22a.75.75 0 0 1 0 1.06L6.56 8l3.72 3.72a.75.75 0 1 1-1.06 1.06l-4.25-4.25a.75.75 0 0 1 0-1.06l4.25-4.25a.75.75 0 0 1 1.06 0Z"/>
          </svg>
        </button>
        <input
          type="number"
          class="spb-year__input"
          [ngModel]="year"
          (ngModelChange)="onYearChange($event)"
          [disabled]="loading" />
        <button
          type="button"
          class="spb-year__step"
          (click)="nextYear()"
          [disabled]="loading"
          aria-label="Next year">
          <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true">
            <path fill="currentColor" d="M5.72 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 1 1-1.06-1.06L9.44 8 5.72 4.28a.75.75 0 0 1 0-1.06Z"/>
          </svg>
        </button>
      </div>
    </div>

    <div class="spb-stats">
      <div class="spb-stat">
        <span class="spb-stat__label" translate>SALESPERSONS</span>
        <span class="spb-stat__value">{{ rows.length }}</span>
      </div>
      <div class="spb-stat">
        <span class="spb-stat__label" translate>ANNUAL_TOTAL</span>
        <span class="spb-stat__value">{{ getGrandTotal() | number:'1.0-0' }}</span>
      </div>
      <div class="spb-stat">
        <span class="spb-stat__label" translate>MONTHLY_AVERAGE</span>
        <span class="spb-stat__value">{{ (rows.length ? getGrandTotal() / 12 : 0) | number:'1.0-0' }}</span>
      </div>
    </div>

    <div class="spb-toolbar__actions">
      <span *ngIf="dirty.size > 0" class="spb-dirty-pill">
        <span class="spb-dirty-dot"></span>
        {{ dirty.size }} <span translate>UNSAVED</span>
      </span>
      <button
        type="button"
        class="spb-btn spb-btn--primary"
        (click)="saveAll()"
        [disabled]="loading || savingAll || dirty.size === 0">
        <span *ngIf="!savingAll" translate>SAVE_ALL</span>
        <span *ngIf="savingAll" translate>SAVING</span>
      </button>
    </div>
  </section>

  <!-- Content card -->
  <section class="spb-card">
    <!-- Loading state -->
    <div *ngIf="loading" class="spb-state">
      <div class="spb-spinner"></div>
      <p translate>LOADING</p>
    </div>

    <!-- Empty state -->
    <div *ngIf="!loading && rows.length === 0" class="spb-state spb-state--empty">
      <div class="spb-state__icon">
        <svg viewBox="0 0 24 24" width="32" height="32" aria-hidden="true">
          <path fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M4 7h16M4 12h16M4 17h10"/>
        </svg>
      </div>
      <h3 class="spb-state__title" translate>NO_BUDGETS_FOR_YEAR</h3>
      <p class="spb-state__desc" translate>NO_BUDGETS_DESC</p>
      <button type="button" class="spb-btn spb-btn--primary" (click)="addRow()">
        <span translate>ADD_ROW</span>
      </button>
    </div>

    <!-- Table -->
    <div *ngIf="!loading && rows.length > 0" class="spb-table-wrap">
      <table class="spb-table">
        <thead>
          <tr>
            <th class="spb-col-id spb-sortable" (click)="toggleSort('salespersonId')">
              <span translate>SALESPERSON_ID</span>
              <span class="spb-sort-ind" *ngIf="sortKey === 'salespersonId'">
                {{ sortAsc ? '↑' : '↓' }}
              </span>
            </th>
            <th
              *ngFor="let m of months"
              class="spb-col-num spb-sortable"
              (click)="toggleSort(sortKeyForMonth(m))">
              <span>{{ 'MONTH_' + m | translate }}</span>
              <span class="spb-sort-ind" *ngIf="sortKey === sortKeyForMonth(m)">
                {{ sortAsc ? '↑' : '↓' }}
              </span>
            </th>
            <th class="spb-col-num spb-col-total spb-sortable" (click)="toggleSort('total')">
              <span translate>TOTAL</span>
              <span class="spb-sort-ind" *ngIf="sortKey === 'total'">
                {{ sortAsc ? '↑' : '↓' }}
              </span>
            </th>
            <th class="spb-col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of rows"
            [class.is-dirty]="isDirty(row)"
            [class.is-error]="row._error"
            [class.is-new]="row._isNew">
            <td class="spb-col-id">
              <input
                type="text"
                class="spb-input spb-input--id"
                [placeholder]="'SALESPERSON_ID' | translate"
                [ngModel]="row.salespersonId"
                (ngModelChange)="onSalespersonIdInput(row, $event)" />
              <div *ngIf="row._error" class="spb-error">{{ row._error }}</div>
            </td>
            <td *ngFor="let m of months" class="spb-col-num">
              <input
                type="number"
                class="spb-input spb-input--num"
                min="0"
                step="1"
                [ngModel]="row.monthlyBudgets[m]"
                (ngModelChange)="onMonthInput(row, m, $event)" />
            </td>
            <td class="spb-col-num spb-col-total">
              {{ getRowTotal(row) | number:'1.0-0' }}
            </td>
            <td class="spb-col-actions">
              <div class="spb-actions">
                <button
                  type="button"
                  class="spb-icon-btn"
                  (click)="saveRow(row)"
                  [disabled]="!isDirty(row)"
                  [attr.aria-label]="'SAVE' | translate"
                  [title]="'SAVE' | translate">
                  <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
                    <path fill="currentColor" d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l2.47 2.47 6.47-6.47a.75.75 0 0 1 1.06 0Z"/>
                  </svg>
                </button>
                <button
                  type="button"
                  class="spb-icon-btn spb-icon-btn--danger"
                  (click)="deleteRow(row)"
                  [attr.aria-label]="'DELETE' | translate"
                  [title]="'DELETE' | translate">
                  <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
                    <path fill="currentColor" d="M6.5 1.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75V3h3.25a.75.75 0 0 1 0 1.5h-.56l-.68 9.17a1.75 1.75 0 0 1-1.74 1.58H6.23a1.75 1.75 0 0 1-1.74-1.58L3.81 4.5H3.25a.75.75 0 0 1 0-1.5H6.5V1.75ZM6.75 6a.75.75 0 0 0-.75.78l.25 5.5a.75.75 0 0 0 1.5-.06l-.25-5.5A.75.75 0 0 0 6.75 6Zm2.5 0a.75.75 0 0 0-.75.72l-.25 5.5a.75.75 0 0 0 1.5.06l.25-5.5A.75.75 0 0 0 9.25 6Z"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="spb-col-id spb-foot-label" translate>COLUMN_TOTAL</td>
            <td *ngFor="let m of months" class="spb-col-num">
              {{ getColumnTotal(m) | number:'1.0-0' }}
            </td>
            <td class="spb-col-num spb-col-total">{{ getGrandTotal() | number:'1.0-0' }}</td>
            <td class="spb-col-actions"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </section>
</div>
